// extracted by mini-css-extract-plugin
export var productionsPageHolder = "productions-module--productionsPageHolder--GDfzR";